import React from "react";
import GlobalStyle from "../../theme/global";
import ChinaCityMap from "../chinaCityMap/ChinaCityMap";

const App = () => {
  return (
    <>
      <GlobalStyle />
      <ChinaCityMap />
    </>
  );
};
export default App;
